import { useMemo, useContext } from 'react';
import _ from 'underscore';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { useJsData } from '@bingads-webui-cc-react/js-data-rest';
import { usePerfMarkerLifecycle } from '@bingads-webui-react/hoc-with-perf-marker';
import { formatInsertionOrderLabel } from '../utils';
import { MaxInsertionOrderLimit } from '../constants';

export const useInsertionOrderData = ({
  i18n,
  searchTerm,
  queryField,
  extraPredicate,
}) => {
  const {
    scope: { values: { cid, aid, uid } },
  } = useContext(ScopeContext);
  const searchPredicate = !_.isEmpty(searchTerm) ? `{"Field":"${queryField}","Operator":2,"Values":"${searchTerm}"}` : '';
  const { data, loading } = useJsData(jsData => jsData.InsertionOrdersGridData.findAll({
    cid,
    aid,
    uid,
    limit: MaxInsertionOrderLimit,
    offset: 0,
    $predicate: `[${[searchPredicate, extraPredicate].filter(p => !_.isEmpty(p)).join(',')}]`,
  }), [searchTerm, cid, aid, uid]);

  usePerfMarkerLifecycle(!loading);

  const { value, total } = (data && data.raw) || {};

  const insertionOrderItems = useMemo(() => {
    if (value) {
      return _.map(value, item => ({
        id: item.InsertionOrderId,
        name: formatInsertionOrderLabel({
          i18n,
          orderName: item.InsertionOrderName,
          seriesName: item.SeriesName,
          startDate: item.StartDateText,
          endDate: item.EndDateText,
          budget: item.SpendCapAmount,
        }),
        selected: false,
        disabled: false,
      }));
    }
    return value;
  }, [i18n, value]);

  return {
    insertionOrderItems: insertionOrderItems || [],
    total,
    loading,
  };
};
